import { makeStyles } from '@material-ui/core/styles';
import { alto, white } from 'styles/jsColors';

const jsStyles = makeStyles({
  tablehead: {
    backgroundColor: alto,
  },
  tablebody: {
    backgroundColor: white,
  },

  headercell: {
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: alto,
    border: 'none',
  },

  stickyheadercell: {
    position: 'sticky',
    left: '0',
    backgroundColor: alto,
    padding: '0 1rem',
    height: '40px',
    minWidth: '150px',
    fontSize: '14px',
    border: 'none',
  },

  stickytotalcell: {
    position: 'sticky',
    backgroundColor: alto,
    right: 0,
  },

  typecell: {
    position: 'sticky',
    left: '0',
    backgroundColor: white,
    padding: '0 1rem',
    height: '40px',
    minWidth: '200px',
    fontSize: '16px',
    border: 'none',
    fontWeight: 'bold',
  },

  cell: {
    padding: '0 1rem',
    height: '40px',
    minWidth: '60px',
    fontSize: '14px',
    border: 'none',
  },

  readonlycell: {
    padding: '0 1rem',
    height: '40px',
    minWidth: '75px',
    fontSize: '14px',
    backgroundColor: alto,
  },
});

export default jsStyles;
